import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

// Attach JWT token from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wfmd_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global 401 handler: clear session and redirect to /login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("wfmd_token");
      localStorage.removeItem("wfmd_user");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

// Download a file (CSV etc.) from the API using current token
export async function downloadFile(path, params = {}, fallbackName = "download.csv") {
  let response;
  try {
    response = await api.get(path, {
      params,
      responseType: "blob",
      headers: { Accept: "text/csv" },
    });
  } catch (err) {
    let detail = "Download failed";
    const data = err?.response?.data;
    if (data instanceof Blob) {
      try {
        const parsed = JSON.parse(await data.text());
        if (parsed?.detail) detail = parsed.detail;
      } catch {}
    } else if (err?.response?.data?.detail) {
      detail = err.response.data.detail;
    }
    throw new Error(detail);
  }
  // Parse filename from Content-Disposition if present
  let filename = fallbackName;
  const cd = response.headers["content-disposition"] || "";
  const match = cd.match(/filename="?([^";]+)"?/i);
  if (match) filename = match[1];
  const blob = response.data;
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objectUrl);
  return filename;
}
